export default "__VITE_ASSET__Gn35mKG9__"